export enum ResetTypeEnum {
  SOFT = "SOFT",
  HARD = "HARD",
}
